// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueResource from 'vue-resource'
import Vuex, { mapState, mapGetters } from 'vuex'
import VCalendar from 'v-calendar'

Vue.use(VCalendar, {
  locale: (() => {
    function getParameterByName (name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }

    return getParameterByName('lang')
  })()
})

Vue.use(Vuex)
Vue.use(VueResource)

// HTTP Interceptors
Vue.http.interceptors.push(function (request, next) {
  // REF: https://stackoverflow.com/questions/39665244/vue-resource-interceptor-for-auth-headers
  // modify headers
  request.headers.set('Content-Type', 'application/json')
  request.headers.set('Accept', 'application/json')
  request.headers.set('x-auth-token', store.state.userAuthToken)
  next()
})

Vue.config.productionTip = false

Vue.mixin({
  computed: {
    ...mapState(['userAuthToken', 'userId', 'userLang', 'userCountry', 'mergedUserAnswers', 'qnResponseOverall']),
    ...mapGetters(['localization', 'authUrl'])
  },
  methods: {
    getUserUrlParam: function (param, fallback = null) {
      // Note: Do not use URLSearchParams as that does not work on older iOS browsers
      // REFERENCE: https://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js
      let getUrlParameter = function getUrlParameter (sParam) {
        let sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i

        for (i = 0; i < sURLVariables.length; i++) {
          let index = sURLVariables[i].indexOf('=') + 1
          sParameterName = []
          sParameterName[0] = sURLVariables[i].substring(0, index - 1)
          sParameterName[1] = decodeURIComponent(sURLVariables[i].substring(index))

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1]
          }
        }
      }

      // If country is undefined, return 'US'
      if (param === 'country') {
        return (getUrlParameter(param) ? getUrlParameter(param) : 'US')
      }

      return getUrlParameter(param) ? getUrlParameter(param) : fallback
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store
})



// WEBPACK FOOTER //
// ./src/main.js